(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-showcase-scroll"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initShowcaseScroll(track) {
      var originals = Array.prototype.slice.call(
        track.querySelectorAll('.customer-showcase-scroll__slide:not(.is-clone)')
      );
      if (!originals.length) return;

      originals.forEach(function (node) {
        var clone = node.cloneNode(true);
        clone.classList.add('is-clone');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });

      var slides = Array.prototype.slice.call(
        track.querySelectorAll('.customer-showcase-scroll__slide')
      );
      var index = 0;
      var paused = false;
      var timer = null;

      function scrollToIndex(i, smooth) {
        track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      }

      function tick() {
        if (paused) return;
        index += 1;
        if (index >= slides.length) {
          index = 0;
          scrollToIndex(index, false);
          return;
        }
        scrollToIndex(index, true);
      }

      function start() {
        stop();
        timer = setInterval(tick, 2000);
      }
      function stop() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      ['pointerdown', 'touchstart'].forEach(function (evt) {
        track.addEventListener(
          evt,
          function () {
            paused = true;
          },
          { passive: true }
        );
      });
      ['pointerup', 'touchend', 'touchcancel', 'mouseleave'].forEach(function (evt) {
        track.addEventListener(
          evt,
          function () {
            paused = false;
          },
          { passive: true }
        );
      });

      start();
    }

    document
      .querySelectorAll('.customer-showcase-scroll__track')
      .forEach(initShowcaseScroll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
